/* @jsxImportSource react */

import type { DimensionFragmentFragment } from '@packages/gql/generated/shopping/graphql';
import type { VariationSelectionOnSelectHandler } from '../types';
import { ColorTile } from './ColorTile/ColorTile.client';

export type ColorTilesDimensionProps = VariationSelectionOnSelectHandler & {
  /**
   * The GraphQL dimension data for the given product
   */
  data: DimensionFragmentFragment['values'];
};

/**
 * ColorTilesDimension to choose a product color on Detailview
 * */
export const ColorTilesDimension = ({ data, onSelect }: ColorTilesDimensionProps) => (
  <div className="mt-0.5 flex flex-row flex-wrap gap-1.5">
    {data.map((dimensionData, index) => (
      <ColorTile
        data={dimensionData}
        // eslint-disable-next-line react/no-array-index-key
        key={`ColorTilesDimensionColorTile${index}`}
        onSelect={onSelect}
      />
    ))}
  </div>
);
